/* Options:
Date: 2024-05-10 16:45:55
Version: 8.22
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://ebelediyeservices.dabto.com

//GlobalNamespace: 
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
//DefaultImports: 
*/


export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IHasSessionId
{
    sessionId?: string;
}

export interface IHasBearerToken
{
    bearerToken?: string;
}

export interface IPost
{
}

export class BaseRequest<E>
{

    public constructor(init?: Partial<BaseRequest<E>>) { (Object as any).assign(this, init); }
}

export class GenWebKisiDto
{
    public ad?: string;
    public adresBlokNo?: string;
    public adresCaddeSokakAd?: string;
    public adresDaireNo?: string;
    public adresIlceKod?: number;
    public adresKapiNo?: number;
    public adresKapiNo1?: string;
    public adresMahalleAd?: string;
    public adresMahalleCaddeKod?: number;
    public adresPostaKodu?: number;
    public adresSiteApartmanAd?: string;
    public adresTuru?: string;
    public anneAd?: string;
    public babaAd?: string;
    public basvuruTuru: number;
    public belediyeKod: number;
    public cinsiyet?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public diniKod?: number;
    public dogumTarih?: string;
    public dogumYeriAciklama?: string;
    public dogumYeriKod?: number;
    public eMail?: string;
    public faxAlanKod?: number;
    public faxNo?: number;
    public gsmAlanKod?: number;
    public gsmNo?: number;
    public kanGrubu?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public medeniDurumKod?: number;
    public meslekAciklama?: string;
    public meslekKod?: number;
    public ogrenimTuruKod?: number;
    public onayDurumu?: string;
    public sifre?: string;
    public sifreHatirlatmaCevap?: string;
    public sifreHatirlatmaSoru?: number;
    public soyad?: string;
    public tckn?: number;
    public telAlanKod?: number;
    public telNo?: number;
    public unvani?: string;
    public uyrukKod?: number;
    public vergiDairesi?: string;
    public vergiNo?: string;

    public constructor(init?: Partial<GenWebKisiDto>) { (Object as any).assign(this, init); }
}

export class CmyBasvuruDto
{
    public ad?: string;
    public basvuruSekliKod: number;
    public basvuruTarih: string;
    public basvuruTuruKod?: number;
    public belediyeKod: number;
    public bimerNo?: number;
    public bimerTarih?: string;
    public cagriDetayKod?: number;
    public cagriKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eMail?: string;
    public eskiKisiKod?: number;
    public faxAlanKod?: number;
    public faxTelefon?: string;
    public gelenEvrakNo?: number;
    public gelenEvrakTarih?: string;
    public gizliEh?: string;
    public gonderIpAdres?: string;
    public gonderMacAdres?: string;
    public gorusmeTurKod?: number;
    public gsmAlanKod?: number;
    public gsmTelefon?: string;
    public ibbBasvuruNo?: string;
    public ibbGelenGiden?: string;
    public ibbGuvenlikNo?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiBinaKod?: number;
    public kisiBlokNo?: string;
    public kisiBolumKod?: number;
    public kisiDaireNo?: string;
    public kisiKapiNo?: number;
    public kisiKapiNo1?: string;
    public kisiKod?: number;
    public kisiMahalleCaddeKod?: number;
    public kisiSiteApartmanAd?: string;
    public kod: number;
    public konuKod: number;
    public koordinatX?: number;
    public koordinatY?: number;
    public muhtarKod?: number;
    public onayEh?: string;
    public onemDereceKod?: number;
    public ortalamaBitisTarih?: string;
    public planKod?: number;
    public sabitAlanKod?: number;
    public sabitTelefon?: string;
    public sonucAciklama?: string;
    public sonucFaxEh?: string;
    public sonucKullaniciKod?: number;
    public sonucMailEh?: string;
    public sonucSmsEh?: string;
    public sonucTarih?: string;
    public sonucTelEh?: string;
    public sonucTurKod?: number;
    public sonucYaziliEh?: string;
    public soyad?: string;
    public status?: number;
    public talepAciklama?: string;
    public talepAciklamaSesPath?: string;
    public talepAdresSesPath?: string;
    public talepBinaKod?: number;
    public talepBlokNo?: string;
    public talepBolumKod?: number;
    public talepDaireNo?: string;
    public talepKapiNo?: number;
    public talepKapiNo1?: string;
    public talepKisaTarif?: string;
    public talepKisiSesPath?: string;
    public talepMahalleCaddeKod?: number;
    public talepSiteApartmanAd?: string;
    public tckn?: number;
    public unvani?: string;

    public constructor(init?: Partial<CmyBasvuruDto>) { (Object as any).assign(this, init); }
}



// @DataContract
export class EbldSpwebparametresorgula_CursorDto
{
    // @DataMember(Name="Kod")
    public Kod: number;

    // @DataMember(Name="AlanKod")
    public AlanKod: number;

    public constructor(init?: Partial<EbldSpwebparametresorgula_CursorDto>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EbldSpctvtarifeyil_CursorDto
{
    // @DataMember(Name="Yil")
    public Yil: number;

    public constructor(init?: Partial<EbldSpctvtarifeyil_CursorDto>) { (Object as any).assign(this, init); }
}

export class BaseCursorDto implements IBaseCursorDto
{

    public constructor(init?: Partial<BaseCursorDto>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EbldSpemlakasinmasorgula_CursorDto
{
    // @DataMember(Name="Rn")
    public Rn: number;

    // @DataMember(Name="TotalCount")
    public TotalCount: number;

    // @DataMember(Name="Kod")
    public Kod: number;

    // @DataMember(Name="Yil")
    public Yil: number;

    // @DataMember(Name="InsaatTurKod")
    public InsaatTurKod: number;

    // @DataMember(Name="IYas")
    public IYas: number;

    // @DataMember(Name="SYas")
    public SYas: number;

    // @DataMember(Name="Orani")
    public Orani: number;

    // @DataMember(Name="KayitTarih")
    public KayitTarih: string;

    // @DataMember(Name="KayitKullaniciKod")
    public KayitKullaniciKod: number;

    // @DataMember(Name="DegisTarih")
    public DegisTarih: string;

    // @DataMember(Name="DegisKullaniciKod")
    public DegisKullaniciKod: number;

    // @DataMember(Name="InsaatTurAck")
    public InsaatTurAck: string;

    public constructor(init?: Partial<EbldSpemlakasinmasorgula_CursorDto>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EbldSpkoddetaysorgula_CursorDto
{
    // @DataMember(Name="Kod")
    public Kod: number;

    // @DataMember(Name="Ad")
    public Ad: string;

    public constructor(init?: Partial<EbldSpkoddetaysorgula_CursorDto>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EbldSpemlakbayindirlikyil_CursorDto
{
    // @DataMember(Name="Yil")
    public Yil: number;

    public constructor(init?: Partial<EbldSpemlakbayindirlikyil_CursorDto>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EbldSpcmykonusorgula_CursorDto
{
    // @DataMember(Name="Kod")
    public Kod: number;

    // @DataMember(Name="Ad")
    public Ad: string;

    public constructor(init?: Partial<EbldSpcmykonusorgula_CursorDto>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EbldSpemlakbayindirliksorgula_CursorDto
{
    // @DataMember(Name="Yil")
    public Yil: number;

    // @DataMember(Name="KullanimSekliAck")
    public KullanimSekliAck: string;

    // @DataMember(Name="InsaatTurAck")
    public InsaatTurAck: string;

    // @DataMember(Name="InsaatSinifAck")
    public InsaatSinifAck: string;

    // @DataMember(Name="Tutar")
    public Tutar: number;

    // @DataMember(Name="TotalCount")
    public TotalCount: number;

    public constructor(init?: Partial<EbldSpemlakbayindirliksorgula_CursorDto>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EbldSpkullanimseklisorgula_CursorDto
{
    // @DataMember(Name="Kod")
    public Kod: number;

    // @DataMember(Name="Aciklama")
    public Aciklama: string;

    public constructor(init?: Partial<EbldSpkullanimseklisorgula_CursorDto>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EbldSptelalankodsorgula_CursorDto
{
    // @DataMember(Name="Kod")
    public Kod: string;

    // @DataMember(Name="AlanKod")
    public AlanKod: string;

    public constructor(init?: Partial<EbldSptelalankodsorgula_CursorDto>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EbldSpctvtarifesorgula_CursorDto
{
    // @DataMember(Name="Rn")
    public Rn: number;

    // @DataMember(Name="TotalCount")
    public TotalCount: number;

    // @DataMember(Name="Kod")
    public Kod: number;

    // @DataMember(Name="BelediyeKod")
    public BelediyeKod: number;

    // @DataMember(Name="Yil")
    public Yil: number;

    // @DataMember(Name="Grup")
    public Grup: number;

    // @DataMember(Name="Derece")
    public Derece: number;

    // @DataMember(Name="Tarife")
    public Tarife: number;

    // @DataMember(Name="KayitTarih")
    public KayitTarih: string;

    // @DataMember(Name="KayitKullaniciKod")
    public KayitKullaniciKod: number;

    // @DataMember(Name="DegisTarih")
    public DegisTarih: string;

    // @DataMember(Name="DegisKullaniciKod")
    public DegisKullaniciKod: number;

    public constructor(init?: Partial<EbldSpctvtarifesorgula_CursorDto>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EbldSptahsilatlarim_CursorDto
{
    // @DataMember(Name="Kod")
    public Kod: number;

    // @DataMember(Name="TahsilTarih")
    public TahsilTarih: string;

    // @DataMember(Name="SeriNo")
    public SeriNo: string;

    // @DataMember(Name="MakbuzNo")
    public MakbuzNo: number;

    // @DataMember(Name="TahsilTutar")
    public TahsilTutar: number;

    // @DataMember(Name="GecikmeZammi")
    public GecikmeZammi: number;

    // @DataMember(Name="ToplamTutar")
    public ToplamTutar: number;

    // @DataMember(Name="KayitSayisi")
    public KayitSayisi: number;

    // @DataMember(Name="RowNo")
    public RowNo: number;

    // @DataMember(Name="Url")
    public Url: string;

    public constructor(init?: Partial<EbldSptahsilatlarim_CursorDto>) { (Object as any).assign(this, init); }
}

export class GenWebKisiProfileDto
{
    public ad?: string;
    public babaAd?: string;
    public belediyeKod: number;
    public eMail?: string;
    public gsmAlanKod?: number;
    public gsmNo?: number;
    public kisiKod?: number;
    public kod: number;
    public onayDurumu?: string;
    public soyad?: string;
    public tckn?: number;
    public telAlanKod?: number;
    public telNo?: number;

    public constructor(init?: Partial<GenWebKisiProfileDto>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EbldSpbeyanlarim_CursorDto
{
    // @DataMember(Name="BeyanTuru")
    public BeyanTuru: string;

    // @DataMember(Name="AdaParsel")
    public AdaParsel: string;

    // @DataMember(Name="KabulTarih")
    public KabulTarih: string;

    // @DataMember(Name="KullanimSekli")
    public KullanimSekli: string;

    // @DataMember(Name="BeyanAdres")
    public BeyanAdres: string;

    // @DataMember(Name="ArsaAlani")
    public ArsaAlani: number;

    // @DataMember(Name="ArsaHisseOran")
    public ArsaHisseOran: string;

    // @DataMember(Name="BinaYuzolcum")
    public BinaYuzolcum: number;

    // @DataMember(Name="BinaHisseOran")
    public BinaHisseOran: string;

    // @DataMember(Name="CtvGrupDerece")
    public CtvGrupDerece: string;

    // @DataMember(Name="IlanM2")
    public IlanM2: number;

    // @DataMember(Name="ModulKod")
    public ModulKod: number;

    // @DataMember(Name="KayitSayisi")
    public KayitSayisi: number;

    // @DataMember(Name="RowNo")
    public RowNo: number;

    public constructor(init?: Partial<EbldSpbeyanlarim_CursorDto>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EbldSpemlakasinmayil_CursorDto
{
    // @DataMember(Name="Yil")
    public Yil: number;

    public constructor(init?: Partial<EbldSpemlakasinmayil_CursorDto>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EbldSpgenkisisorgula_CursorDto
{
    // @DataMember(Name="Kod")
    public Kod: number;

    // @DataMember(Name="BelediyeKod")
    public BelediyeKod: number;

    // @DataMember(Name="KisiTurKod")
    public KisiTurKod: number;

    // @DataMember(Name="SicilKod")
    public SicilKod: number;

    // @DataMember(Name="IsyeriTuruKod")
    public IsyeriTuruKod: number;

    // @DataMember(Name="Tckn")
    public Tckn: number;

    // @DataMember(Name="Ad")
    public Ad: string;

    // @DataMember(Name="Soyad")
    public Soyad: string;

    // @DataMember(Name="Unvani")
    public Unvani: string;

    // @DataMember(Name="BabaAd")
    public BabaAd: string;

    // @DataMember(Name="AnneAd")
    public AnneAd: string;

    // @DataMember(Name="Cinsiyet")
    public Cinsiyet: string;

    // @DataMember(Name="OncekiSoyad")
    public OncekiSoyad: string;

    // @DataMember(Name="DogumTarih")
    public DogumTarih: string;

    // @DataMember(Name="DogumYeriKod")
    public DogumYeriKod: number;

    // @DataMember(Name="DogumYeriAciklama")
    public DogumYeriAciklama: string;

    // @DataMember(Name="NKayitliYerKod")
    public NKayitliYerKod: number;

    // @DataMember(Name="NKayitliMahalleKoy")
    public NKayitliMahalleKoy: string;

    // @DataMember(Name="NCiltNo")
    public NCiltNo: string;

    // @DataMember(Name="NAileSiraNo")
    public NAileSiraNo: string;

    // @DataMember(Name="NSiraNo")
    public NSiraNo: string;

    // @DataMember(Name="NCuzdanSeriNo")
    public NCuzdanSeriNo: string;

    // @DataMember(Name="NCuzdanSiraNo")
    public NCuzdanSiraNo: number;

    // @DataMember(Name="NCuzdanVerilisKod")
    public NCuzdanVerilisKod: number;

    // @DataMember(Name="NCuzdanKayitNo")
    public NCuzdanKayitNo: string;

    // @DataMember(Name="NIdaresiKod")
    public NIdaresiKod: number;

    // @DataMember(Name="NVerildigiTarih")
    public NVerildigiTarih: string;

    // @DataMember(Name="KanGrubu")
    public KanGrubu: string;

    // @DataMember(Name="MedeniDurumKod")
    public MedeniDurumKod: number;

    // @DataMember(Name="DiniKod")
    public DiniKod: number;

    // @DataMember(Name="UyrukKod")
    public UyrukKod: number;

    // @DataMember(Name="EmekliTuruKod")
    public EmekliTuruKod: number;

    // @DataMember(Name="EmekliTarih")
    public EmekliTarih: string;

    // @DataMember(Name="OlumKapanisTarih")
    public OlumKapanisTarih: string;

    // @DataMember(Name="VarisEh")
    public VarisEh: string;

    // @DataMember(Name="VergiDairesi")
    public VergiDairesi: string;

    // @DataMember(Name="VergiNo")
    public VergiNo: string;

    // @DataMember(Name="MeslekKod")
    public MeslekKod: number;

    // @DataMember(Name="MeslekAciklama")
    public MeslekAciklama: string;

    // @DataMember(Name="OgrenimTuruKod")
    public OgrenimTuruKod: number;

    // @DataMember(Name="EhliyetTuruKod")
    public EhliyetTuruKod: number;

    // @DataMember(Name="EhliyetNo")
    public EhliyetNo: string;

    // @DataMember(Name="EhliyetTarih")
    public EhliyetTarih: string;

    // @DataMember(Name="Aciklama")
    public Aciklama: string;

    // @DataMember(Name="KayitTarih")
    public KayitTarih: string;

    // @DataMember(Name="KayitKullaniciKod")
    public KayitKullaniciKod: number;

    // @DataMember(Name="DegisTarih")
    public DegisTarih: string;

    // @DataMember(Name="DegisKullaniciKod")
    public DegisKullaniciKod: number;

    public constructor(init?: Partial<EbldSpgenkisisorgula_CursorDto>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EbldSprayicsorgula_CursorDto
{
    // @DataMember(Name="Rn")
    public Rn: number;

    // @DataMember(Name="TotalCount")
    public TotalCount: number;

    // @DataMember(Name="MahalleAd")
    public MahalleAd: string;

    // @DataMember(Name="CaddeSokakAd")
    public CaddeSokakAd: string;

    // @DataMember(Name="Yil")
    public Yil: number;

    // @DataMember(Name="ArsaM2")
    public ArsaM2: number;

    public constructor(init?: Partial<EbldSprayicsorgula_CursorDto>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EbldSpcaddesokaksorgula_CursorDto
{
    // @DataMember(Name="MahalleCaddeSokakKod")
    public MahalleCaddeSokakKod: number;

    // @DataMember(Name="CaddeSokakKod")
    public CaddeSokakKod: number;

    // @DataMember(Name="CaddeSokakAd")
    public CaddeSokakAd: string;

    public constructor(init?: Partial<EbldSpcaddesokaksorgula_CursorDto>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EbldSpcmybasvurusorgula_CursorDto
{
    // @DataMember(Name="Kod")
    public Kod: number;

    // @DataMember(Name="BelediyeKod")
    public BelediyeKod: number;

    // @DataMember(Name="BasvuruTarih")
    public BasvuruTarih: string;

    // @DataMember(Name="BasvuruSekliKod")
    public BasvuruSekliKod: number;

    // @DataMember(Name="BasvuruTuruKod")
    public BasvuruTuruKod: number;

    // @DataMember(Name="KisiKod")
    public KisiKod: number;

    // @DataMember(Name="Tckn")
    public Tckn: number;

    // @DataMember(Name="Ad")
    public Ad: string;

    // @DataMember(Name="Soyad")
    public Soyad: string;

    // @DataMember(Name="Unvani")
    public Unvani: string;

    // @DataMember(Name="EMail")
    public EMail: string;

    // @DataMember(Name="GizliEh")
    public GizliEh: string;

    // @DataMember(Name="KisiMahalleCaddeKod")
    public KisiMahalleCaddeKod: number;

    // @DataMember(Name="KisiKapiNo")
    public KisiKapiNo: number;

    // @DataMember(Name="KisiKapiNo1")
    public KisiKapiNo1: string;

    // @DataMember(Name="KisiDaireNo")
    public KisiDaireNo: string;

    // @DataMember(Name="KisiSiteApartmanAd")
    public KisiSiteApartmanAd: string;

    // @DataMember(Name="KisiBlokNo")
    public KisiBlokNo: string;

    // @DataMember(Name="KisiBinaKod")
    public KisiBinaKod: number;

    // @DataMember(Name="KisiBolumKod")
    public KisiBolumKod: number;

    // @DataMember(Name="GsmAlanKod")
    public GsmAlanKod: number;

    // @DataMember(Name="GsmTelefon")
    public GsmTelefon: string;

    // @DataMember(Name="SabitAlanKod")
    public SabitAlanKod: number;

    // @DataMember(Name="SabitTelefon")
    public SabitTelefon: string;

    // @DataMember(Name="FaxAlanKod")
    public FaxAlanKod: number;

    // @DataMember(Name="FaxTelefon")
    public FaxTelefon: string;

    // @DataMember(Name="TalepMahalleCaddeKod")
    public TalepMahalleCaddeKod: number;

    // @DataMember(Name="TalepKapiNo")
    public TalepKapiNo: number;

    // @DataMember(Name="TalepKapiNo1")
    public TalepKapiNo1: string;

    // @DataMember(Name="TalepDaireNo")
    public TalepDaireNo: string;

    // @DataMember(Name="TalepSiteApartmanAd")
    public TalepSiteApartmanAd: string;

    // @DataMember(Name="TalepBlokNo")
    public TalepBlokNo: string;

    // @DataMember(Name="TalepBinaKod")
    public TalepBinaKod: number;

    // @DataMember(Name="TalepBolumKod")
    public TalepBolumKod: number;

    // @DataMember(Name="TalepKisaTarif")
    public TalepKisaTarif: string;

    // @DataMember(Name="KoordinatX")
    public KoordinatX: number;

    // @DataMember(Name="KoordinatY")
    public KoordinatY: number;

    // @DataMember(Name="KonuKod")
    public KonuKod: number;

    // @DataMember(Name="TalepAciklama")
    public TalepAciklama: string;

    // @DataMember(Name="OrtalamaBitisTarih")
    public OrtalamaBitisTarih: string;

    // @DataMember(Name="OnemDereceKod")
    public OnemDereceKod: number;

    // @DataMember(Name="OnayEh")
    public OnayEh: string;

    // @DataMember(Name="SonucMailEh")
    public SonucMailEh: string;

    // @DataMember(Name="SonucSmsEh")
    public SonucSmsEh: string;

    // @DataMember(Name="SonucTelEh")
    public SonucTelEh: string;

    // @DataMember(Name="SonucYaziliEh")
    public SonucYaziliEh: string;

    // @DataMember(Name="SonucFaxEh")
    public SonucFaxEh: string;

    // @DataMember(Name="GelenEvrakNo")
    public GelenEvrakNo: number;

    // @DataMember(Name="GelenEvrakTarih")
    public GelenEvrakTarih: string;

    // @DataMember(Name="BimerNo")
    public BimerNo: number;

    // @DataMember(Name="BimerTarih")
    public BimerTarih: string;

    // @DataMember(Name="TalepKisiSesPath")
    public TalepKisiSesPath: string;

    // @DataMember(Name="TalepAciklamaSesPath")
    public TalepAciklamaSesPath: string;

    // @DataMember(Name="TalepAdresSesPath")
    public TalepAdresSesPath: string;

    // @DataMember(Name="CagriKod")
    public CagriKod: number;

    // @DataMember(Name="CagriDetayKod")
    public CagriDetayKod: number;

    // @DataMember(Name="GonderIpAdres")
    public GonderIpAdres: string;

    // @DataMember(Name="GonderMacAdres")
    public GonderMacAdres: string;

    // @DataMember(Name="SonucTurKod")
    public SonucTurKod: number;

    // @DataMember(Name="SonucTarih")
    public SonucTarih: string;

    // @DataMember(Name="SonucAciklama")
    public SonucAciklama: string;

    // @DataMember(Name="PlanKod")
    public PlanKod: number;

    // @DataMember(Name="KayitTarih")
    public KayitTarih: string;

    // @DataMember(Name="KayitKullaniciKod")
    public KayitKullaniciKod: number;

    // @DataMember(Name="DegisTarih")
    public DegisTarih: string;

    // @DataMember(Name="DegisKullaniciKod")
    public DegisKullaniciKod: number;

    // @DataMember(Name="EskiKisiKod")
    public EskiKisiKod: number;

    // @DataMember(Name="Status")
    public Status: number;

    // @DataMember(Name="IbbGelenGiden")
    public IbbGelenGiden: string;

    // @DataMember(Name="IbbBasvuruNo")
    public IbbBasvuruNo: string;

    // @DataMember(Name="IbbGuvenlikNo")
    public IbbGuvenlikNo: string;

    // @DataMember(Name="SonucKullaniciKod")
    public SonucKullaniciKod: number;

    // @DataMember(Name="GorusmeTurKod")
    public GorusmeTurKod: number;

    // @DataMember(Name="MuhtarKod")
    public MuhtarKod: number;

    // @DataMember(Name="SonucTurAck")
    public SonucTurAck: string;

    // @DataMember(Name="PlanAck")
    public PlanAck: string;

    public constructor(init?: Partial<EbldSpcmybasvurusorgula_CursorDto>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EbldSpmahallesorgula_CursorDto
{
    // @DataMember(Name="MahalleKod")
    public MahalleKod: number;

    // @DataMember(Name="Ad")
    public Ad: string;

    public constructor(init?: Partial<EbldSpmahallesorgula_CursorDto>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EbldSpmecliskararlari_CursorDto
{
    // @DataMember(Name="KararTarih")
    public KararTarih: string;

    // @DataMember(Name="KararNo")
    public KararNo: string;

    // @DataMember(Name="KararAciklama")
    public KararAciklama: string;

    // @DataMember(Name="KayitSayisi")
    public KayitSayisi: number;

    // @DataMember(Name="RowNo")
    public RowNo: number;

    public constructor(init?: Partial<EbldSpmecliskararlari_CursorDto>) { (Object as any).assign(this, init); }
}

// YIS_KARAR'dan e-Belediye'ye açılan Meclis/Encümen kararı (Ebld_YisKararListele_Request)
export class EbldYisKararDto
{
    public kod: number;
    public kararNo: string;
    public kararTarih: string;
    public kararAciklama: string;
    public konuAdi: string;
    // Yalnız Meclis kararlarında ve metin DYS'de varsa true; Encümen için hep false
    public pdfVar: boolean;

    public constructor(init?: Partial<EbldYisKararDto>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseError
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public fieldName: string;

    // @DataMember(Order=3)
    public message: string;

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseStatus
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message: string;

    // @DataMember(Order=3)
    public stackTrace: string;

    // @DataMember(Order=4)
    public errors: ResponseError[];

    // @DataMember(Order=5)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

export interface IBaseCursorDto
{
}

export class BaseResponse
{
    public result: boolean;
    public errorCode: string;
    public errorMessage: string;
    public errors: string[];
    public warnings: string[];
    public errorDetails: string[];
    public totalPages: number;
    public totalCount: number;
    public pageSize: number;

    public constructor(init?: Partial<BaseResponse>) { (Object as any).assign(this, init); }
}

export class Ebld_CardKontrol_Response extends BaseResponse
{
    public xkod: string;
    public bnk: string;
    public tak: string;
    public tip: string;
    public bAdi: string;

    public constructor(init?: Partial<Ebld_CardKontrol_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpWebParametreSorgula_Response extends BaseResponse
{
    public parametreList: EbldSpwebparametresorgula_CursorDto[];

    public constructor(init?: Partial<Ebld_SpWebParametreSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpCtvTarifeYil_Response extends BaseResponse
{
    public tarifeYilList: EbldSpctvtarifeyil_CursorDto[];

    public constructor(init?: Partial<Ebld_SpCtvTarifeYil_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpDilekceTakip_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<Ebld_SpDilekceTakip_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpEmlakAsinmaSorgula_Response extends BaseResponse
{
    public emlakAsinmaList: EbldSpemlakasinmasorgula_CursorDto[];

    public constructor(init?: Partial<Ebld_SpEmlakAsinmaSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpKodDetaySorgula_Response extends BaseResponse
{
    public kodDetayList: EbldSpkoddetaysorgula_CursorDto[];

    public constructor(init?: Partial<Ebld_SpKodDetaySorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpMaaslarim_Response extends BaseResponse
{
    public poMaaslar: BaseCursorDto[];

    public constructor(init?: Partial<Ebld_SpMaaslarim_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpEmlakBayindirlikYil_Response extends BaseResponse
{
    public emlakBayindirlikYilList: EbldSpemlakbayindirlikyil_CursorDto[];

    public constructor(init?: Partial<Ebld_SpEmlakBayindirlikYil_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpKartKontrol_Response extends BaseResponse
{
    public pCevap: Object;
    public poBanka: Object;

    public constructor(init?: Partial<Ebld_SpKartKontrol_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpCmyKonuSorgula_Response extends BaseResponse
{
    public konuSorgulaList: EbldSpcmykonusorgula_CursorDto[];

    public constructor(init?: Partial<Ebld_SpCmyKonuSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpEdevletGiris_Response extends BaseResponse
{
    public poSifre: string;

    public constructor(init?: Partial<Ebld_SpEdevletGiris_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpEmlakBayindirlikSorgula_Response extends BaseResponse
{
    public emlakBayindirlikList: EbldSpemlakbayindirliksorgula_CursorDto[];

    public constructor(init?: Partial<Ebld_SpEmlakBayindirlikSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpKullanimSekliSorgula_Response extends BaseResponse
{
    public kullanimSekliList: EbldSpkullanimseklisorgula_CursorDto[];

    public constructor(init?: Partial<Ebld_SpKullanimSekliSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpTahsilKontrol_Response extends BaseResponse
{
    public poAdet: number;
    public poGecikmeZamFark: number;

    public constructor(init?: Partial<Ebld_SpTahsilKontrol_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpTelAlankodSorgula_Response extends BaseResponse
{
    public alankodListe: EbldSptelalankodsorgula_CursorDto[];

    public constructor(init?: Partial<Ebld_SpTelAlankodSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpVposTaksitTahsilatYap_Response extends BaseResponse
{
    public poTarih: string;
    public poMakbuzNo: number;
    public poMakbuzUrl: string;

    public constructor(init?: Partial<Ebld_SpVposTaksitTahsilatYap_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpCtvTarifeSorgula_Response extends BaseResponse
{
    public tarifeSorgulaList: EbldSpctvtarifesorgula_CursorDto[];

    public constructor(init?: Partial<Ebld_SpCtvTarifeSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpIlceSorgula_Response extends BaseResponse
{
    public poRefCursor: BaseCursorDto[];

    public constructor(init?: Partial<Ebld_SpIlceSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpTahsilatlarim_Response extends BaseResponse
{
    public tahsilatlarList: EbldSptahsilatlarim_CursorDto[];

    public constructor(init?: Partial<Ebld_SpTahsilatlarim_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpTaksitliBorcSorgula_Response extends BaseResponse
{
    public poBorclar: BaseCursorDto[];

    public constructor(init?: Partial<Ebld_SpTaksitliBorcSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpBorcSorgula_Response extends BaseResponse
{
    public poRefCursor: BaseCursorDto[];

    public constructor(init?: Partial<Ebld_SpBorcSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpBorcSorgulaWeb_Response extends BaseResponse
{
    public poRefCursor: BaseCursorDto[];

    public constructor(init?: Partial<Ebld_SpBorcSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_WebKisiProfile_Response extends BaseResponse
{
    public webKisi: GenWebKisiProfileDto;

    public constructor(init?: Partial<Ebld_WebKisiProfile_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_WebKisiKaydet_Response extends BaseResponse
{

    public constructor(init?: Partial<Ebld_WebKisiKaydet_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_IstekSikayetBelgeKaydet_Response extends BaseResponse
{

    public constructor(init?: Partial<Ebld_IstekSikayetBelgeKaydet_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpWebKullaniciDogrula_Response extends BaseResponse
{
    public poAd: string;
    public poSoyad: string;
    public poUnvani: string;
    public poKisiKod: number;
    public poKisiId: number;
    public poBasvuruTur: number;
    public poEmail: string;
    public poGsmTel: string;

    public constructor(init?: Partial<Ebld_SpWebKullaniciDogrula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpBeyanlarim_Response extends BaseResponse
{
    public beyanlarimList: EbldSpbeyanlarim_CursorDto[];

    public constructor(init?: Partial<Ebld_SpBeyanlarim_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpEmlakAsinmaYil_Response extends BaseResponse
{
    public emlakAsinmaYilList: EbldSpemlakasinmayil_CursorDto[];

    public constructor(init?: Partial<Ebld_SpEmlakAsinmaYil_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpEncmenKararlari_Response extends BaseResponse
{
    public poEncumenKarar: BaseCursorDto[];

    public constructor(init?: Partial<Ebld_SpEncmenKararlari_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpGenKisiSorgula_Response extends BaseResponse
{
    public kisiSorgulaList: EbldSpgenkisisorgula_CursorDto[];

    public constructor(init?: Partial<Ebld_SpGenKisiSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpIlSorgula_Response extends BaseResponse
{
    public poRefCursor: BaseCursorDto[];

    public constructor(init?: Partial<Ebld_SpIlSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpRayicSorgula_Response extends BaseResponse
{
    public rayicList: EbldSprayicsorgula_CursorDto[];

    public constructor(init?: Partial<Ebld_SpRayicSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpVposTahsilatYap_Response extends BaseResponse
{
    public poTarih: string;
    public poMakbuzNo: number;
    public poMakbuzUrl: string;

    public constructor(init?: Partial<Ebld_SpVposTahsilatYap_Response>) { super(init); (Object as any).assign(this, init); }
}

export class FnIntResponse extends BaseResponse
{
    public fnResult: number;

    public constructor(init?: Partial<FnIntResponse>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_FnEimzaBelgeTakip_Response extends FnIntResponse
{
    public docContent: string;

    public constructor(init?: Partial<Ebld_FnEimzaBelgeTakip_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpCaddeSokakSorgula_Response extends BaseResponse
{
    public caddeSokakList: EbldSpcaddesokaksorgula_CursorDto[];

    public constructor(init?: Partial<Ebld_SpCaddeSokakSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpCmyBasvuruSorgula_Response extends BaseResponse
{
    public basvuruSorgulaList: EbldSpcmybasvurusorgula_CursorDto[];

    public constructor(init?: Partial<Ebld_SpCmyBasvuruSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpKisiler_Response extends BaseResponse
{
    public poKisiler: BaseCursorDto[];

    public constructor(init?: Partial<Ebld_SpKisiler_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpMahalleSorgula_Response extends BaseResponse
{
    public mahalleList: EbldSpmahallesorgula_CursorDto[];

    public constructor(init?: Partial<Ebld_SpMahalleSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpMeclisKararlari_Response extends BaseResponse
{
    public meclisKararlariList: EbldSpmecliskararlari_CursorDto[];

    public constructor(init?: Partial<Ebld_SpMeclisKararlari_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_YisKararListele_Response extends BaseResponse
{
    public kararList: EbldYisKararDto[];
    public override totalCount: number;

    public constructor(init?: Partial<Ebld_YisKararListele_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_YisKararPdf_Response extends BaseResponse
{
    public pdfContent: string;  // base64
    public dosyaAdi: string;

    public constructor(init?: Partial<Ebld_YisKararPdf_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpRayicYilSorgula_Response extends BaseResponse
{
    public poRefCursor: BaseCursorDto[];

    public constructor(init?: Partial<Ebld_SpRayicYilSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SpVposOrderOku_Response extends BaseResponse
{
    public poSorgu: Object;
    public poBilgi: BaseCursorDto[];

    public constructor(init?: Partial<Ebld_SpVposOrderOku_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Ebld_SmsVerification_Response extends BaseResponse
{
    public Success: boolean;
    public Message: string;
    public VerificationId : string;
    public uyeliksizBelirtec?: string; // DKM-5080: SMS'in gönderildiği kişiye bağlı üyeliksiz işlem belirteci

    public constructor(init?: Partial<Ebld_SmsVerification_Response>) { super(init); (Object as any).assign(this, init); }
}
export class Ebld_SendSms_Response extends BaseResponse
{
    public Success: boolean;
    public Message: string;
    public PhoneNumber : string;

    public constructor(init?: Partial<Ebld_SendSms_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Nestpay3DPaymentResult extends BaseResponse
{
    public RedirectUrl : string;
    public PaymentForm : string;
    public TransactionId : string;

    public constructor(init?: Partial<Nestpay3DPaymentResult>) { super(init); (Object as any).assign(this, init); }
}
// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public referrerUrl: string;

    // @DataMember(Order=6)
    public bearerToken: string;

    // @DataMember(Order=7)
    public refreshToken: string;

    // @DataMember(Order=8)
    public refreshTokenExpiry?: string;

    // @DataMember(Order=9)
    public profileUrl: string;

    // @DataMember(Order=10)
    public roles: string[];

    // @DataMember(Order=11)
    public permissions: string[];

    // @DataMember(Order=12)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=13)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UnAssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UnAssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @Route("/EBL/PgEbldServis/CardKontrol")
export class Ebld_CardKontrol_Request extends BaseRequest<Ebld_CardKontrol_Response> implements IReturn<Ebld_CardKontrol_Response>
{
    public card: string;
    public bkod: number;

    public constructor(init?: Partial<Ebld_CardKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_CardKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_CardKontrol_Response(); }
}

// @Route("/EBL/PgEbldServis/SpWebParametreSorgula")
export class Ebld_SpWebParametreSorgula_Request extends BaseRequest<Ebld_SpWebParametreSorgula_Response> implements IReturn<Ebld_SpWebParametreSorgula_Response>
{

    public constructor(init?: Partial<Ebld_SpWebParametreSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpWebParametreSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpWebParametreSorgula_Response(); }
}

// @Route("/EBL/PgEbldServis/SpCtvTarifeYil")
export class Ebld_SpCtvTarifeYil_Request extends BaseRequest<Ebld_SpCtvTarifeYil_Response> implements IReturn<Ebld_SpCtvTarifeYil_Response>
{

    public constructor(init?: Partial<Ebld_SpCtvTarifeYil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpCtvTarifeYil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpCtvTarifeYil_Response(); }
}

// @Route("/EBL/PgEbldServis/SpDilekceTakip")
export class Ebld_SpDilekceTakip_Request extends BaseRequest<Ebld_SpDilekceTakip_Response> implements IReturn<Ebld_SpDilekceTakip_Response>
{
    public piBelgeReferans: number;
    public piTckn: number;

    public constructor(init?: Partial<Ebld_SpDilekceTakip_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpDilekceTakip_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpDilekceTakip_Response(); }
}

// @Route("/EBL/PgEbldServis/SpEmlakAsinmaSorgula")
export class Ebld_SpEmlakAsinmaSorgula_Request extends BaseRequest<Ebld_SpEmlakAsinmaSorgula_Response> implements IReturn<Ebld_SpEmlakAsinmaSorgula_Response>
{
    public piYil?: number;
    public piInsaatTur?: number;
    public piStart: number;
    public piLimit: number;
    public piStatu?: number;

    public constructor(init?: Partial<Ebld_SpEmlakAsinmaSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpEmlakAsinmaSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpEmlakAsinmaSorgula_Response(); }
}

// @Route("/EBL/PgEbldServis/SpKodDetaySorgula")
export class Ebld_SpKodDetaySorgula_Request extends BaseRequest<Ebld_SpKodDetaySorgula_Response> implements IReturn<Ebld_SpKodDetaySorgula_Response>
{
    public piAnaKod?: number;

    public constructor(init?: Partial<Ebld_SpKodDetaySorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpKodDetaySorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpKodDetaySorgula_Response(); }
}

// @Route("/EBL/PgEbldServis/SpMaaslarim")
export class Ebld_SpMaaslarim_Request extends BaseRequest<Ebld_SpMaaslarim_Response> implements IReturn<Ebld_SpMaaslarim_Response>
{
    public piTckn: number;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<Ebld_SpMaaslarim_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpMaaslarim_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpMaaslarim_Response(); }
}

// @Route("/EBL/PgEbldServis/SpWebKisiGuncelle")
export class Ebld_SpWebKisiGuncelle_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piKod: number;
    public piAd: string;
    public piSoyad: string;
    public piUnvani: string;
    public piEMail: string;
    public piSifre: string;
    public piKisiKod: number;
    public piTckn: number;
    public piVergiNo: string;
    public piGsmAlanKod: number;
    public piGsmNo: number;
    public piOnayDurumu: string;

    public constructor(init?: Partial<Ebld_SpWebKisiGuncelle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpWebKisiGuncelle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/EBL/PgEbldServis/SpEmlakBayindirlikYil")
export class Ebld_SpEmlakBayindirlikYil_Request extends BaseRequest<Ebld_SpEmlakBayindirlikYil_Response> implements IReturn<Ebld_SpEmlakBayindirlikYil_Response>
{

    public constructor(init?: Partial<Ebld_SpEmlakBayindirlikYil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpEmlakBayindirlikYil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpEmlakBayindirlikYil_Response(); }
}

// @Route("/EBL/PgEbldServis/SpKartKontrol")
export class Ebld_SpKartKontrol_Request extends BaseRequest<Ebld_SpKartKontrol_Response> implements IReturn<Ebld_SpKartKontrol_Response>
{
    public pSorgu: Object;

    public constructor(init?: Partial<Ebld_SpKartKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpKartKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpKartKontrol_Response(); }
}

// @Route("/EBL/PgEbldServis/SpSifreGonder")
export class Ebld_SpSifreGonder_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piKod: number;

    public constructor(init?: Partial<Ebld_SpSifreGonder_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpSifreGonder_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/EBL/PgEbldServis/SpTahsilBorcKontrol")
export class Ebld_SpTahsilBorcKontrol_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piKisiKod: number;
    public piBorc: Object;

    public constructor(init?: Partial<Ebld_SpTahsilBorcKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpTahsilBorcKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/EBL/PgEbldServis/SpCmyKonuSorgula")
export class Ebld_SpCmyKonuSorgula_Request extends BaseRequest<Ebld_SpCmyKonuSorgula_Response> implements IReturn<Ebld_SpCmyKonuSorgula_Response>
{
    public piWebEh?: string;

    public constructor(init?: Partial<Ebld_SpCmyKonuSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpCmyKonuSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpCmyKonuSorgula_Response(); }
}

// @Route("/EBL/PgEbldServis/SpEdevletGiris")
export class Ebld_SpEdevletGiris_Request extends BaseRequest<Ebld_SpEdevletGiris_Response> implements IReturn<Ebld_SpEdevletGiris_Response>
{
    public piTckn: number;

    public constructor(init?: Partial<Ebld_SpEdevletGiris_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpEdevletGiris_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpEdevletGiris_Response(); }
}

// @Route("/EBL/PgEbldServis/SpEmlakBayindirlikSorgula")
export class Ebld_SpEmlakBayindirlikSorgula_Request extends BaseRequest<Ebld_SpEmlakBayindirlikSorgula_Response> implements IReturn<Ebld_SpEmlakBayindirlikSorgula_Response>
{
    public piYil?: number;
    public piKullanimSekli?: number;
    public piKullanimSinif?: number;
    public piStart: number;
    public piLimit: number;
    public piStatus?: number;

    public constructor(init?: Partial<Ebld_SpEmlakBayindirlikSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpEmlakBayindirlikSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpEmlakBayindirlikSorgula_Response(); }
}

// @Route("/EBL/PgEbldServis/SpKullanimSekliSorgula")
export class Ebld_SpKullanimSekliSorgula_Request extends BaseRequest<Ebld_SpKullanimSekliSorgula_Response> implements IReturn<Ebld_SpKullanimSekliSorgula_Response>
{

    public constructor(init?: Partial<Ebld_SpKullanimSekliSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpKullanimSekliSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpKullanimSekliSorgula_Response(); }
}

// @Route("/EBL/PgEbldServis/SpTahsilKontrol")
export class Ebld_SpTahsilKontrol_Request extends BaseRequest<Ebld_SpTahsilKontrol_Response> implements IReturn<Ebld_SpTahsilKontrol_Response>
{
    public piKisiKod: number;
    public piBorc: Object;

    public constructor(init?: Partial<Ebld_SpTahsilKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpTahsilKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpTahsilKontrol_Response(); }
}

// @Route("/EBL/PgEbldServis/SpTelAlankodSorgula")
export class Ebld_SpTelAlankodSorgula_Request extends BaseRequest<Ebld_SpTelAlankodSorgula_Response> implements IReturn<Ebld_SpTelAlankodSorgula_Response>
{
    public piGsmEh?: string;

    public constructor(init?: Partial<Ebld_SpTelAlankodSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpTelAlankodSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpTelAlankodSorgula_Response(); }
}

// @Route("/EBL/PgEbldServis/SpVposTaksitTahsilatYap")
export class Ebld_SpVposTaksitTahsilatYap_Request extends BaseRequest<Ebld_SpVposTaksitTahsilatYap_Response> implements IReturn<Ebld_SpVposTaksitTahsilatYap_Response>
{
    public pSorgu: Object;
    public pTaksitAnaKod: number;
    public pTaksitSiraNo: number;

    public constructor(init?: Partial<Ebld_SpVposTaksitTahsilatYap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpVposTaksitTahsilatYap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpVposTaksitTahsilatYap_Response(); }
}

// @Route("/EBL/PgEbldServis/SpWebEmailDegistir")
export class Ebld_SpWebEmailDegistir_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piKisiId: number;
    public piEmail: string;

    public constructor(init?: Partial<Ebld_SpWebEmailDegistir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpWebEmailDegistir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/EBL/PgEbldServis/SpCtvTarifeSorgula")
export class Ebld_SpCtvTarifeSorgula_Request extends BaseRequest<Ebld_SpCtvTarifeSorgula_Response> implements IReturn<Ebld_SpCtvTarifeSorgula_Response>
{
    public piYil?: number;
    public piStart: number;
    public piLimit: number;
    public piStatu?: number;

    public constructor(init?: Partial<Ebld_SpCtvTarifeSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpCtvTarifeSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpCtvTarifeSorgula_Response(); }
}

// @Route("/EBL/PgEbldServis/SpIlceSorgula")
export class Ebld_SpIlceSorgula_Request extends BaseRequest<Ebld_SpIlceSorgula_Response> implements IReturn<Ebld_SpIlceSorgula_Response>
{
    public piIlKod?: number;

    public constructor(init?: Partial<Ebld_SpIlceSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpIlceSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpIlceSorgula_Response(); }
}

// @Route("/EBL/PgEbldServis/SpTahsilatlarim")
export class Ebld_SpTahsilatlarim_Request extends BaseRequest<Ebld_SpTahsilatlarim_Response> implements IReturn<Ebld_SpTahsilatlarim_Response>
{
    public piKisiKod: number;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<Ebld_SpTahsilatlarim_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpTahsilatlarim_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpTahsilatlarim_Response(); }
}

// @Route("/EBL/PgEbldServis/SpTaksitliBorcSorgula")
export class Ebld_SpTaksitliBorcSorgula_Request extends BaseRequest<Ebld_SpTaksitliBorcSorgula_Response> implements IReturn<Ebld_SpTaksitliBorcSorgula_Response>
{
    public piKisiKod: number;
    public piIslemTuru: string;
    public UyeliksizBelirtec?: string; // DKM-5080
    public constructor(init?: Partial<Ebld_SpTaksitliBorcSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpTaksitliBorcSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpTaksitliBorcSorgula_Response(); }
}

// @Route("/EBL/PgEbldServis/SpBorcSorgula")
export class Ebld_SpBorcSorgula_Request extends BaseRequest<Ebld_SpBorcSorgula_Response> implements IReturn<Ebld_SpBorcSorgula_Response>
{
    public piKisiKod: string;
    public piIslemTuru: string;
    public phoneNumber : string;
    public piTaksitAnaKod: string;
    public piTaksit: string;



    public constructor(init?: Partial<Ebld_SpBorcSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpBorcSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpBorcSorgula_Response(); }
}

export class Ebld_SpBorcSorgulaWeb_Request extends BaseRequest<Ebld_SpBorcSorgulaWeb_Response> implements IReturn<Ebld_SpBorcSorgulaWeb_Response>
{
    public piKisiKod: string;
    public UyeliksizBelirtec?: string; // DKM-5080
    public piIslemTuru: string;
    public phoneNumber : string;
    public verificationCode : string;
    public piTaksit: string;
    public piTaksitAnaKod: string;



    public constructor(init?: Partial<Ebld_SpBorcSorgulaWeb_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpBorcSorgulaWeb_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpBorcSorgulaWeb_Response(); }
}

// @Route("/EBL/PgEbldServis/WebKisiProfile")
export class Ebld_WebKisiProfile_Request extends BaseRequest<Ebld_WebKisiProfile_Response> implements IReturn<Ebld_WebKisiProfile_Response>
{

    public constructor(init?: Partial<Ebld_WebKisiProfile_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_WebKisiProfile_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_WebKisiProfile_Response(); }
}

// @Route("/EBL/PgEbldServis/WebKisiKaydet")
export class Ebld_WebKisiKaydet_Request extends BaseRequest<Ebld_WebKisiKaydet_Response> implements IReturn<Ebld_WebKisiKaydet_Response>
{
    public genWebKisi: GenWebKisiDto;

    public constructor(init?: Partial<Ebld_WebKisiKaydet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_WebKisiKaydet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_WebKisiKaydet_Response(); }
}

// @Route("/EBL/PgEbldServis/IstekSikayetBelgeKaydet")
export class Ebld_IstekSikayetBelgeKaydet_Request extends BaseRequest<Ebld_IstekSikayetBelgeKaydet_Response> implements IReturn<Ebld_IstekSikayetBelgeKaydet_Response>
{
    public cmyBasvuru: CmyBasvuruDto;
    public fileContent: string;
    public fileName: string;

    public constructor(init?: Partial<Ebld_IstekSikayetBelgeKaydet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_IstekSikayetBelgeKaydet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_IstekSikayetBelgeKaydet_Response(); }
}

// @Route("/EBL/PgEbldServis/SpWebKullaniciDogrula")
export class Ebld_SpWebKullaniciDogrula_Request extends BaseRequest<Ebld_SpWebKullaniciDogrula_Response> implements IReturn<Ebld_SpWebKullaniciDogrula_Response>
{
    public piSifre: string;
    public piIpAdres: string;

    public constructor(init?: Partial<Ebld_SpWebKullaniciDogrula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpWebKullaniciDogrula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpWebKullaniciDogrula_Response(); }
}

// @Route("/EBL/PgEbldServis/SpBeyanlarim")
export class Ebld_SpBeyanlarim_Request extends BaseRequest<Ebld_SpBeyanlarim_Response> implements IReturn<Ebld_SpBeyanlarim_Response>
{
    public piKisiKod: number;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<Ebld_SpBeyanlarim_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpBeyanlarim_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpBeyanlarim_Response(); }
}

// @Route("/EBL/PgEbldServis/SpEmlakAsinmaYil")
export class Ebld_SpEmlakAsinmaYil_Request extends BaseRequest<Ebld_SpEmlakAsinmaYil_Response> implements IReturn<Ebld_SpEmlakAsinmaYil_Response>
{

    public constructor(init?: Partial<Ebld_SpEmlakAsinmaYil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpEmlakAsinmaYil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpEmlakAsinmaYil_Response(); }
}

// @Route("/EBL/PgEbldServis/SpEncmenKararlari")
export class Ebld_SpEncmenKararlari_Request extends BaseRequest<Ebld_SpEncmenKararlari_Response> implements IReturn<Ebld_SpEncmenKararlari_Response>
{
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<Ebld_SpEncmenKararlari_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpEncmenKararlari_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpEncmenKararlari_Response(); }
}

// @Route("/EBL/PgEbldServis/SpGenKisiSorgula")
export class Ebld_SpGenKisiSorgula_Request extends BaseRequest<Ebld_SpGenKisiSorgula_Response> implements IReturn<Ebld_SpGenKisiSorgula_Response>
{
    public piSorgulamaTuru?: string;
    public piTcNo?: number;
    public piAd?: string;
    public piSoyad?: string;
    public piBabaad?: string;
    public piDogumTarih?: string;
    public piVergiNo?: string;
    public piUnvan?: string;

    public constructor(init?: Partial<Ebld_SpGenKisiSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpGenKisiSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpGenKisiSorgula_Response(); }
}

// @Route("/EBL/PgEbldServis/SpIlSorgula")
export class Ebld_SpIlSorgula_Request extends BaseRequest<Ebld_SpIlSorgula_Response> implements IReturn<Ebld_SpIlSorgula_Response>
{

    public constructor(init?: Partial<Ebld_SpIlSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpIlSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpIlSorgula_Response(); }
}

// @Route("/EBL/PgEbldServis/SpRayicSorgula")
export class Ebld_SpRayicSorgula_Request extends BaseRequest<Ebld_SpRayicSorgula_Response> implements IReturn<Ebld_SpRayicSorgula_Response>
{
    public piMahalleKod?: number;
    public piCaddeSokakKod?: number;
    public piYil?: number;
    public piStart: number;
    public piLimit: number;
    public piStatu?: number;

    public constructor(init?: Partial<Ebld_SpRayicSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpRayicSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpRayicSorgula_Response(); }
}

// @Route("/EBL/PgEbldServis/SpSifremiUnuttum")
export class Ebld_SpSifremiUnuttum_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piTckVergi: number;

    public constructor(init?: Partial<Ebld_SpSifremiUnuttum_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpSifremiUnuttum_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/EBL/PgEbldServis/SpVposOrderYaz")
export class Ebld_SpVposOrderYaz_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public pSorgu: Object;

    public constructor(init?: Partial<Ebld_SpVposOrderYaz_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpVposOrderYaz_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/EBL/PgEbldServis/SpVposTahsilatYap")
export class Ebld_SpVposTahsilatYap_Request extends BaseRequest<Ebld_SpVposTahsilatYap_Response> implements IReturn<Ebld_SpVposTahsilatYap_Response>
{
    public pSorgu: Object;

    public constructor(init?: Partial<Ebld_SpVposTahsilatYap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpVposTahsilatYap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpVposTahsilatYap_Response(); }
}

// @Route("/EBL/PgEbldServis/SpWebGsmDegistir")
export class Ebld_SpWebGsmDegistir_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piKisiId: number;
    public piGsmAlanKod: number;
    public piGsmNo: number;

    public constructor(init?: Partial<Ebld_SpWebGsmDegistir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpWebGsmDegistir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/EBL/PgEbldServis/SpWebSifreDegistir")
export class Ebld_SpWebSifreDegistir_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piKisiId: number;
    public piEskiSifre: string;
    public piYeniSifre: string;

    public constructor(init?: Partial<Ebld_SpWebSifreDegistir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpWebSifreDegistir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/EBL/PgEbldServis/FnEimzaBelgeTakip")
export class Ebld_FnEimzaBelgeTakip_Request implements IReturn<Ebld_FnEimzaBelgeTakip_Response>
{
    public piBarkod: string;

    public constructor(init?: Partial<Ebld_FnEimzaBelgeTakip_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_FnEimzaBelgeTakip_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_FnEimzaBelgeTakip_Response(); }
}

// @Route("/EBL/PgEbldServis/FnRayicDetaySorgula")
export class Ebld_FnRayicDetaySorgula_Request implements IReturn<FnIntResponse>
{
    public piEmlakRayicKod: number;

    public constructor(init?: Partial<Ebld_FnRayicDetaySorgula_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_FnRayicDetaySorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/EBL/PgEbldServis/SpCaddeSokakSorgula")
export class Ebld_SpCaddeSokakSorgula_Request extends BaseRequest<Ebld_SpCaddeSokakSorgula_Response> implements IReturn<Ebld_SpCaddeSokakSorgula_Response>
{
    public piMahalleKod?: number;

    public constructor(init?: Partial<Ebld_SpCaddeSokakSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpCaddeSokakSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpCaddeSokakSorgula_Response(); }
}

// @Route("/EBL/PgEbldServis/SpCmyBasvuruSorgula")
export class Ebld_SpCmyBasvuruSorgula_Request extends BaseRequest<Ebld_SpCmyBasvuruSorgula_Response> implements IReturn<Ebld_SpCmyBasvuruSorgula_Response>
{
    public piBasvuruNo?: number;
    public piEmail?: string;

    public constructor(init?: Partial<Ebld_SpCmyBasvuruSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpCmyBasvuruSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpCmyBasvuruSorgula_Response(); }
}

// @Route("/EBL/PgEbldServis/SpKisiler")
export class Ebld_SpKisiler_Request extends BaseRequest<Ebld_SpKisiler_Response> implements IReturn<Ebld_SpKisiler_Response>
{
    public piKisiKod: number;
    public piTckn: number;
    public piAd: string;
    public piSoyad: string;
    public piUnvan: string;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<Ebld_SpKisiler_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpKisiler_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpKisiler_Response(); }
}

// @Route("/EBL/PgEbldServis/SpMahalleSorgula")
export class Ebld_SpMahalleSorgula_Request extends BaseRequest<Ebld_SpMahalleSorgula_Response> implements IReturn<Ebld_SpMahalleSorgula_Response>
{

    public constructor(init?: Partial<Ebld_SpMahalleSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpMahalleSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpMahalleSorgula_Response(); }
}

// @Route("/EBL/PgEbldServis/SpMailGonder")
export class Ebld_SpMailGonder_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piMailAdi: string;
    public piBaslik: string;
    public piDosyaAdi: string;

    public constructor(init?: Partial<Ebld_SpMailGonder_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpMailGonder_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/EBL/PgEbldServis/SpMeclisKararlari")
export class Ebld_SpMeclisKararlari_Request extends BaseRequest<Ebld_SpMeclisKararlari_Response> implements IReturn<Ebld_SpMeclisKararlari_Response>
{
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<Ebld_SpMeclisKararlari_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpMeclisKararlari_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpMeclisKararlari_Response(); }
}

// @Route("/EBL/Ebld/YisKararListele")  grupTurKod: 1 Meclis, 2 Encümen
export class Ebld_YisKararListele_Request extends BaseRequest<Ebld_YisKararListele_Response> implements IReturn<Ebld_YisKararListele_Response>
{
    public grupTurKod: number;
    public skip: number;
    public take: number;

    public constructor(init?: Partial<Ebld_YisKararListele_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_YisKararListele_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_YisKararListele_Response(); }
}

// @Route("/EBL/Ebld/YisKararPdf")  yalnız Meclis kararı; Word metni sunucuda PDF'e çevrilir
export class Ebld_YisKararPdf_Request extends BaseRequest<Ebld_YisKararPdf_Response> implements IReturn<Ebld_YisKararPdf_Response>
{
    public kod: number;

    public constructor(init?: Partial<Ebld_YisKararPdf_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_YisKararPdf_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_YisKararPdf_Response(); }
}

// @Route("/EBL/PgEbldServis/SpRayicYilSorgula")
export class Ebld_SpRayicYilSorgula_Request extends BaseRequest<Ebld_SpRayicYilSorgula_Response> implements IReturn<Ebld_SpRayicYilSorgula_Response>
{

    public constructor(init?: Partial<Ebld_SpRayicYilSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpRayicYilSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpRayicYilSorgula_Response(); }
}

// @Route("/EBL/PgEbldServis/SpVposOrderOku")
export class Ebld_SpVposOrderOku_Request extends BaseRequest<Ebld_SpVposOrderOku_Response> implements IReturn<Ebld_SpVposOrderOku_Response>
{
    public piProvizyon: string;

    public constructor(init?: Partial<Ebld_SpVposOrderOku_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpVposOrderOku_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SpVposOrderOku_Response(); }
}

// @Route("/EBL/PgEbldServis/FnHalkOrderIdAl")
export class Ebld_FnHalkOrderIdAl_Request implements IReturn<FnIntResponse>
{

    public constructor(init?: Partial<Ebld_FnHalkOrderIdAl_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_FnHalkOrderIdAl_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/EBL/PgEbldServis/SpVposOrderHataYaz")
export class Ebld_SpVposOrderHataYaz_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piProvizyon: string;
    public piAciklama: string;

    public constructor(init?: Partial<Ebld_SpVposOrderHataYaz_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpVposOrderHataYaz_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/EBL/PgEbldServis/SpWebKisiSil")
export class Ebld_SpWebKisiSil_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piKod: number;

    public constructor(init?: Partial<Ebld_SpWebKisiSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SpWebKisiSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/EBL/PgEbldServis/Ebld_SmsVerification_Request")
export class Ebld_SmsVerification_Request extends BaseRequest<Ebld_SmsVerification_Response> implements IReturn<Ebld_SmsVerification_Response>
{
    public PhoneNumber: string;
    public SmsToken: string;

    public constructor(init?: Partial<Ebld_SmsVerification_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SmsVerification_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SmsVerification_Response(); }
}

// @Route("/EBL/PgEbldServis/Ebld_SendSms_Request")
export class Ebld_SendSms_Request extends BaseRequest<Ebld_SendSms_Response> implements IReturn<Ebld_SendSms_Response>
{
    public IslemTuru: string;
    public Kod: string;

    public constructor(init?: Partial<Ebld_SendSms_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_SendSms_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_SendSms_Response(); }
}

// @Route("/EBL/PgEbldServis/CreateNestpay3DPaymentRequest ")
export class CreateNestpay3DPaymentRequest  extends BaseRequest<Nestpay3DPaymentResult> implements IReturn<Nestpay3DPaymentResult>
{
    public PiKisiKod : string; //long
	public Amount : number; //decimal
	public CardNumber : string;
	public CardHolderName : string;
	public ExpiryMonth : number; //int
	public ExpiryYear : number; //int
	public CVV : string;
	public Installment : number; //int
	public PiTahsilKodList : string[]; //List<long>
	public PiIslemKod : string;
	public UyeliksizBelirtec?: string; // DKM-5080

    public constructor(init?: Partial<CreateNestpay3DPaymentRequest >) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateNestpay3DPaymentRequest '; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Nestpay3DPaymentResult(); }
}

export class Ebld_CmyBasvurularim_Response extends BaseResponse
{
    public List: CmyBasvuruDto[];

    public constructor(init?: Partial<Ebld_CmyBasvurularim_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/EBL/PgEbldServis/SpCmyBasvuruSorgula")
export class Ebld_CmyBasvurularim_Request extends BaseRequest<Ebld_CmyBasvurularim_Response> implements IReturn<Ebld_CmyBasvurularim_Response>
{
    public piBasvuruNo?: number;
    public piEmail?: string;
    public piStart?: number;
    public piLimit?: number;
    public piStatu?: number;

    public constructor(init?: Partial<Ebld_CmyBasvurularim_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_CmyBasvurularim_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_CmyBasvurularim_Response(); }
}

export class Ebld_GetTahsilatMakbuz_Response extends BaseResponse
{

    public constructor(init?: Partial<Ebld_GetTahsilatMakbuz_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/EBL/PgEbldServis/SpCmyBasvuruSorgula")
export class Ebld_GetTahsilatMakbuz_Request extends BaseRequest<Ebld_GetTahsilatMakbuz_Response> implements IReturn<Ebld_GetTahsilatMakbuz_Response>
{
    public TahsilAnaKod?: string;
    public UyeliksizBelirtec?: string; // DKM-5080

    public constructor(init?: Partial<Ebld_GetTahsilatMakbuz_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_GetTahsilatMakbuz_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_GetTahsilatMakbuz_Response(); }
}

// @Route("/EBL/PgEbldServis/TahsilatMakbuzEposta")
// @Route("/Ebld_TahsilatMakbuzEposta_Request")
export class Ebld_TahsilatMakbuzEposta_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public WebKisiKod?: number;
    public KisiKod?: number;
    public TahsilAnaKod: number;

    public constructor(init?: Partial<Ebld_TahsilatMakbuzEposta_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_TahsilatMakbuzEposta_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}


/** @description Sign In */
// @Route("/auth", "GET,POST")
// @Route("/auth/{provider}", "GET,POST")
// @Api(Description="Sign In")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    /** @description AuthProvider, e.g. credentials */
    // @DataMember(Order=1)
    public provider: string;

    // @DataMember(Order=2)
    public userName: string;

    // @DataMember(Order=3)
    public password: string;

    // @DataMember(Order=4)
    public rememberMe?: boolean;

    // @DataMember(Order=5)
    public accessToken: string;

    // @DataMember(Order=6)
    public accessTokenSecret: string;

    // @DataMember(Order=7)
    public returnUrl: string;

    // @DataMember(Order=8)
    public errorView: string;

    // @DataMember(Order=9)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Authenticate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AuthenticateResponse(); }
}

// @Route("/assignroles", "POST")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssignRolesResponse(); }
}

// @Route("/unassignroles", "POST")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<UnAssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnAssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UnAssignRolesResponse(); }
}

export class ModelValidation
{

    public constructor(init?: Partial<ModelValidation>) { (Object as any).assign(this, init); }
}

export enum Currency
{
    JPY = 392,
    RUB = 643,
    GBP = 826,
    USD = 840,
    TRY = 949,
    EUR = 978,
}

export class SaleInfo extends ModelValidation
{
    public cardNameSurname: string;
    public cardNumber: string;
    public cardExpiryDateMonth: number;
    public cardExpiryDateYear: number;
    public cardCVV: string;
    public currency?: Currency;
    public amount: number;
    public point?: number;
    public installment: number;
    public campaignCode: string;

    public constructor(init?: Partial<SaleInfo>) { super(init); (Object as any).assign(this, init); }
}

export class TY_GYS_BORC
{
    public isNull: boolean;
    public moduL_KOD?: number;
    public tahakkuK_KOD?: number;
    public taksiT_KOD?: number;
    public geliR_KOD?: number;
    public detaY_GELIR_KOD?: number;
    public yil?: number;
    public donem?: number;
    public beyaN_KOD?: number;
    public eK_VERGI_EH: string;
    public sU_ABONE_KOD?: number;
    public sU_OKUMA_KOD?: number;
    public referanS_KOD?: number;
    public borC_VERGI?: number;
    public borC_GECIKME_FAIZ?: number;
    public gecikmE_ZAMMI?: number;
    public vadE_TARIH?: string;
    public takiplI_EH: string;
    public hkP_IS_KOD?: number;
    public hkP_BEYAN_KOD?: number;
    public indiriM_TUTAR?: number;
    public gecikmE_KOD?: number;
    public sirA_NO?: number;
    public detaY_GELIR_AD: string;
    public beyaN_ADRES: string;

    public constructor(init?: Partial<TY_GYS_BORC>) { (Object as any).assign(this, init); }
}

export class Ebld_UyeliksizHizliTahsilat_Response extends BaseResponse
{
    public conversationId: string;
    public content: string;

    public constructor(init?: Partial<Ebld_UyeliksizHizliTahsilat_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/EBL/PgEbldServis/UyeliksizHizliTahsilat")
export class Ebld_UyeliksizHizliTahsilat_Request extends BaseRequest<Ebld_UyeliksizHizliTahsilat_Response> implements IReturn<Ebld_UyeliksizHizliTahsilat_Response>
{
    public kisiKod: number;
    public saleInfo: SaleInfo;
    public borcListe: TY_GYS_BORC[];

    public constructor(init?: Partial<Ebld_UyeliksizHizliTahsilat_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ebld_UyeliksizHizliTahsilat_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Ebld_UyeliksizHizliTahsilat_Response(); }
}

